export default __webpack_public_path__ + "static/straight-cup-dark-green-db635c82f08563eb07856f81cf12c3c5.png";